import { render } from "./CalendarIcon.vue?vue&type=template&id=fb0da02c"
const script = {}

import exportComponent from "C:\\laragon\\www\\carzoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__